import { Footer as BrFooter } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Page } from '../../types/footer';

export type FooterProps = {
  pages: Page[];
};

export const Footer: FunctionComponent<FooterProps> = ({ pages }) => {
  const { t } = useTranslation();
  return (
    <BrFooter>
      <BrFooter.ModuleMetaNav
        metaSectionLabel={t('app:footer:companyInfo')}
        copyrightText={`${t('app:footer:copyright')} ${new Date().getFullYear()}`}
      >
        {pages.length &&
          pages.map((currentPage) => (
            <BrFooter.ModuleMetaNav.Item
              key={currentPage.name ? currentPage.name : undefined}
              href={currentPage.url ? currentPage.url : undefined}
              linkProps={{
                target: currentPage.target ?? undefined,
                normalLink: true,
              }}
            >
              {currentPage.name}
            </BrFooter.ModuleMetaNav.Item>
          ))}
        <span className="c-footer-meta-nav__link">{t('app:footer:pricingNotice')}</span>
      </BrFooter.ModuleMetaNav>
    </BrFooter>
  );
};
